<template>
    <div class="refund-wrap">
        <!-- 退款弹框 -->
        <a-modal
            :visible="visibleRefund"
            title='发起退款申请'
            @cancel="closeModalRefund"
            @ok="handleCreateRefund(false)"
            :confirmLoading="confirmLoading"
            :width="900"
            :destroyOnClose="true"
            >
            <div>
                <member-card :ticketData="data" :showOwner="false"></member-card>
            </div>
            <a-form class="refund-form" layout="horizontal" :form="formModelRefund">
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="已退款金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-input placeholder="请输入" disabled :value="ticketDetail.refundAmount" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="可退款金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-input placeholder="请输入" disabled :value="ticketDetail.payAmount - ticketDetail.refundAmount" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="剩余次数金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-input placeholder="请输入" disabled :value="balance" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="退款金额" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-input-number style="width:100%" placeholder="请输入" :min="0" :max="ticketDetail.payAmount - ticketDetail.refundAmount" :precision="2" v-decorator="['applyRefundAmount',{rules: [{required: true, message: '请输入退款金额',}]}]" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <remark :labelSpan="4" :wrapperSpan="18" operateCode="TicketRefund" />
                <div class="ml16 mb8" style="color: #000">退款审核</div>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="审核人职位" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true" >
                            <a-select placeholder="请选择" :labelInValue="true" @change="handleSelectChange">
                                <a-select-option :value="item.id" v-for="item in comfirmRoleList" :key="item.id" >{{item.roleName}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="审核人" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                            <a-select placeholder="请选择" v-decorator="['auditorId',{rules: [{required: true, message: '请选择审核人',}]}]">
                                <a-select-option :value="item.id" v-for="item in memberList" :key="item.id" >{{item.name}}</a-select-option>
                            </a-select>
                    </a-form-item>
                    </a-col>
                </a-row>
                <div class="text-fail" v-if="payMode == 3 || payMode == 4 || (payMode == 11 && isManualPayment)">*该笔订单系统无法自动退款。请先在系统内发起“退款”申请，再完成线下退款流程</div>
            </a-form>
            <div v-show="Boolean(visibleRefund) && Boolean(giveSelectorLength)" class="mb16">
                <a-divider  class="no-margin_top"></a-divider>
                <div class="give-info-container">
                    <div class="mb8">
                        <span class="font-bigger text-color-85">赠品信息</span>
                        <span class="text-primary ml24">该退款票券为活动主商品，是否将购买该商品所赠送的赠品进行退款</span>
                    </div>
                    <member-order-give-selector :owner="ticketData.phone" :ticketGivenId="ticketData.userTicketNo" :disabled="true" type="refund" ref="giveSelector"></member-order-give-selector>
                </div>
            </div>
            <span class="text-fail">*是否发送短息通知由审核人在审核过程中选择</span>
        </a-modal>
        <!-- 操作积分、储值余额不足提示 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="提示"
        :visible="visibleConfirm"
        @cancel="visibleConfirm = false"
        :width="420"
        >
            <div>
                该笔订单积分、储值余额不足，是否继续进行退款申请？
            </div>
            <div>
                退款通过后，该账户积分、储值余额将会清0。
            </div>
            <template slot="footer">
                <a-button @click="visibleConfirm = false">取消</a-button>
                <a-button type="primary" @click="handleCreateRefund(true)">确定</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 退款组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visibleRefund 控制退款弹窗是否显示
     *
     * @func closeModalRefund 通知父组件关闭退款弹窗
     */
    import memberCard from "@/components/modules/order/member-card.component";
    import memberOrderGiveSelector from '@/components/modules/order/member-order-give-selector.component'
    import remark from '@/components/modules/platform/remark.component';
    import { mapGetters } from "vuex";
    export default {
        name: "member-order-refund",
        zh: "退款组件",
        data() {
            return {
                labelCol: {span: 8},
                wrapperCol: {span: 16},
                //基础卡对象
                data: {},
                //审核人职位
                comfirmRoleList: [],
                //所有审核人
                comfirmMemberList: [],
                //当前职位下的审核人
                memberList: [],
                // 余额
                balance: '',
                maxAmount: undefined,
                restCount: 0,
                position: '',
                auditer: '',
                confirmLoading: false,
                visibleConfirm: false,
                giveSelectorLength: 0,
                ticketDetail: {},
                payMode: undefined,
                isManualPayment: false
            };
        },
        props: {
            ticketData: {type: Object},
            visibleRefund: {type: Boolean},
        },
        components: {
            memberCard,
            memberOrderGiveSelector,
            remark
        },
        computed: {
            ...mapGetters(["shopId", "shopName"]),
        },
        methods: {
            handleCreateRefund(ignoreNotEnough) {
                this.formModelRefund.validateFields((err, values) => {
                    if (!err) {
                        const ticketDetail = this.$utils.deepClone(this.ticketDetail);
                        ticketDetail.giveGrantId = this.ticketData.giveGrantId;
                        ticketDetail.applyRefundAmount = values.applyRefundAmount;
                        if(!this.position) {
                            this.$message.error('请选择审核人职位')
                            return false
                        }
                        if(!values.auditorId) {
                            this.$message.error('请选择审核人')
                            return false
                        }
                        if (!ticketDetail.transNo) {
                            this.$message.error('请先选择退款票券')
                            return false
                        }
                        ticketDetail.gifts = ticketDetail.gifts && ticketDetail.gifts.filter(i => {
                            return i.statusStr == "未使用" || i.statusStr == "已生效";
                        });
                        this.confirmLoading = true;
                        this.$api.order.refundOrderList({
                            body: {
                                transNo: ticketDetail.transNo,
                                category: ticketDetail.category,
                                count: ticketDetail.count,
                                orderNo: ticketDetail.orderNo,
                                source: ticketDetail.source,
                                payAmount: ticketDetail.payAmount,
                                refundMode: 0,
                                reason: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                goodsReturn: [ticketDetail],
                                auditId: values.auditorId,
                                auditer: this.memberList.find(el => values.auditorId == el.id).name,
                                account: this.data.phone,
                                userId: this.data.userId,
                                shopId: this.shopId,
                                shopName: this.shopName,
                            }
                        }).then(res => {
                            this.confirmLoading = false;
                            this.$message.success('操作成功');
                            this.formModelRefund.resetFields();
                            setTimeout(() => {
                                this.closeModalRefund();
                            }, 700);
                            this.visibleConfirm = false;
                        }).catch(err => {
                            this.confirmLoading = false;
                            if (err && err.code === 200001) {
                                this.$message.error(err.msg);
                            }
                        });
                    }
                });
            },

            closeModalRefund() {
                this.$eventBus.emit('refreshAutid');
                this.$emit('changeVisibleRefund', false);
            },
            //审核人职位
            comfirmRole() {
                if(!this.shopId) return
                this.$api.audit.sysRoleRefund({}).then(res => {
                    this.comfirmRoleList = res;
                });
            },

            //审核人 根据职位筛选
            comfirmMember() {
                if(!this.shopId) return
                this.$api.audit.sysUserRefund({
                    query: {
                        shopId: this.shopId,
                        roleId: this.position,
                    }
                }).then(res => {
                    this.memberList = res.filter(i => i.id !== this.loginInfo.id);
                });
            },

            //切换审核人职位下拉时，改变审核人下拉为当前职位下的人
            handleSelectChange(value) {
                // value.key: 职位ID，value.label: 职位name
                this.formModelRefund.setFieldsValue({auditorId: ''})
                this.position = value.key;
                this.comfirmMember();
            },
            // 获取购票订单列表
            getDetail() {
                this.$api.order.getRefundDetail({
                    params: {
                        orderNo: this.ticketData.orderNo,
                    }
                }).then(res => {
                    this.ticketDetail = res.find( el => el.businessId == this.ticketData.userTicketNo) || {}
                    if (this.data.totalNum == -1 || this.data.type != 2) {
                        this.balance = this.ticketDetail.payAmount;
                    } else {
                        this.balance = (this.ticketDetail.payAmount * (this.data.totalNum - this.data.usedNum) / this.data.totalNum).toFixed(2);
                    }
                });
            },
            getOrderDetail() {
                this.$api.order.getOrderDetail({
                    body: {
                        transNo: this.data.tradeNo,
                    }
                }).then(res => {
                    this.payMode = res.payMode;
                    this.isManualPayment = res.isManualPayment;
                });
            },
        },
        beforeCreate() {
            this.formModelRefund = this.$form.createForm(this);
            this.loginInfo = this.$userInfoTool.getUser();
        },
        created() {},
        updated() {},
        mounted() {
            this.comfirmRole();
        },
        watch: {
            'ticketData'(val) {
                this.data = val;
                this.restCount = val.total === -1 ? Infinity : (val.total - val.used);
                this.maxAmount = val.restAmount;
            },
            "visibleRefund"(val) {
                if (val) {
                    this.getDetail()
                    this.getOrderDetail()
                    this.$nextTick(() => {
                        this.$refs.giveSelector.getUserTicketGiveInfoVo().then(res => {
                            this.giveSelectorLength = res && res.length;
                        })
                    })
                }
            },
            'shopId'() {
                this.comfirmRole()
            }
        }
    };
</script>

<style lang="scss">
    .give-info-container {
        background-color: #f3f3f3;
        padding: 14px;
    }
</style>
